const brands = [
    {
        id: 1,
        name: 'Apple',
    },
    {
        id: 2,
        name: 'Samsung',
    },
    {
        id: 3,
        name: 'Microsoft',
    },
    {
        id: 4,
        name: 'Sony',
    },
    {
        id: 5,
        name: 'LG',
    },
    {
        id: 6,
        name: 'JBL',
    },
    {
        id: 7,
        name: 'Logitech',
    },
    {
        id: 8,
        name: 'HP',
    },
    {
        id: 9,
        name: 'Dell',
    },
    {
        id: 10,
        name: 'Lenovo',
    },
];
export default brands;
